import { Box, Typography } from '@mui/material';
import { Email as EmailIcon } from '@mui/icons-material';
import CenteredContent from 'components/shared/CenteredContent';
import { useUI } from 'hooks/useUI';

interface NotEmbeddedHeaderProps {
	isEmbedded: boolean;
	isBusinessLoaded: boolean;
	logo: any;
	businessName: string;
	bizContactEmails: string[];
}

function NotEmbeddedHeader({ isEmbedded, isBusinessLoaded, logo, businessName, bizContactEmails }: NotEmbeddedHeaderProps) {
	if (isEmbedded || !isBusinessLoaded) {
		return null;
	}

	return (
		<Box
			sx={{
				padding: '10px',
				boxShadow: '0px 4px 6px -1px rgba(0,0,0,0.1), 0px 4px 5px 0px rgba(0,0,0,0.07), 0px 1px 10px 0px rgba(0,0,0,0.05)',
			}}
		>
			<CenteredContent>
				<Box display="flex" sx={{ width: '100%', flexDirection: {xs: 'column', sm: 'row' } }}>
					<Box display="flex" sx={{ justifyContent: 'center' }}>
						{logo.hasLogo && logo.url ? (
							<img src={logo.url} alt={businessName} style={{ width: logo.dimensions.width, height: logo.dimensions.height }} />
						) : (
							<Typography sx={{ fontSize: '2em', fontWeight: 'bold' }}>{businessName}</Typography>
						)}
					</Box>
					{bizContactEmails.length && (
						<Box sx={{ flexGrow: 1, fontSize: '1.1em', textAlign: 'right', justifyItems: 'right', justifyContent: { xs: 'center', sm: 'flex-end' }, display: 'flex' }}>
							<table>
								<tbody>
									{bizContactEmails.map((email: string, index: number) => (
										<tr key={index}>
											<td style={{ verticalAlign: 'middle' }}><EmailIcon sx={{ marginTop: '9px', marginRight: '10px' }} /></td>
											<td style={{ verticalAlign: 'middle' }}>{email}</td>
										</tr>
									))}
								</tbody>
							</table>
						</Box>
					)}
				</Box>
			</CenteredContent>
		</Box>
	);
}

export default NotEmbeddedHeader;